export default __webpack_public_path__ + "static/media/ChildsFutureProtectBenefit.19f119be.png";